import React from "react";
import { Link } from "react-router-dom";

function CTA({
  subtitle = "Start Your Transformation",
  title = "Your transformation starts inside.",
  link = "/performance",
  ctaText = "Start 3 days Trial",
  backgroundImage = "assets/images/daily/cta-bg.jpg",
  accentColor = "#05AAE3",
}) {
  return (
    <section
      className="section-lgx pbmit-element-team-style-2"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
      }}
    >
      <div className="container">
        <div className="pbmit-heading-subheading animation-style1">
          <h4 className="pbmit-subtitle" style={{ color: accentColor }}>
            <span></span>
            {subtitle}
          </h4>
        </div>

        <div className="row align-items-center">
          {/* LEFT CONTENT */}
          <div className="col-md-9">
            <article className="pbmit-team-style-2">
              <div className="pbminfotech-post-item">
                <div className="pbminfotech-box-content d-flex align-items-center">
                  <div className="pbminfotech-box-content-inner">
                    <h3
                      className="pbmit-team-title"
                      style={{ color: accentColor }}
                    >
                      <Link to={link}>{title}</Link>
                    </h3>

                    <div className="pbminfotech-team-tran-thumb">
                      <img
                        src="images/demo1/team/team-thumb-transparent.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>

          {/* RIGHT CTA */}
          <div className="col-md-3">
            <div className="pbmit-ihbox pbmit-ihbox-style-1 d-flex justify-content-end">
              <Link className="pbmit-ihbox-wrap-link" to={link}>
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-svg">
                    <div className="pbmit-ihbox-svg-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="19"
                        viewBox="0 0 19 19"
                      >
                        <line x1="1" y1="18" x2="17.8" y2="1.2" />
                        <line x1="1.2" y1="1" x2="18" y2="1" />
                        <line x1="18" y1="17.8" x2="18" y2="1" />
                      </svg>
                    </div>
                  </div>

                  <svg viewBox="0 0 200 200">
                    <defs>
                      <path
                        id="txt-path"
                        d="M0,100a100,100 0 1,0 200,0a100,100 0 1,0 -200,0"
                      />
                    </defs>
                    <text>
                      <textPath href="#txt-path">{ctaText}</textPath>
                    </text>
                  </svg>
                </div>

                <div className="pbmit-ihbox-headingicon">
                  <div className="pbmit-ihbox-headingicon-inner"></div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
